import endOfDay from 'date-fns/endOfDay';
import startOfDay from 'date-fns/startOfDay';
import subMonths from 'date-fns/subMonths';
import { FunctionMap, BoardAnalyticsState } from '../../types';
import { createReducer } from './Utils';

import { SetAnalyticsDateRange, SetAnalyticsPlatforms, SetAnalyticsInterval, FSAInterface } from '../actions';
import {
  SET_ANALYTICS_DATE_RANGE,
  GET_BOARD_ANALYTICS_SUCCESS,
  SET_ANALYTICS_PLATFORMS,
  SET_ANALYTICS_INTERVAL,
} from '../constants';

const defaultFromDate = startOfDay(subMonths(new Date(), 1));
const defaultToDate = endOfDay(new Date());

const initialState: BoardAnalyticsState = {
  filters: {
    dateFrom: defaultFromDate,
    dateTo: defaultToDate,
    platforms: [],
    interval: 'day',
  },
  data: {
    postScore: 0,
    customLinkCount: 0,
    engagementCount: 0,
    postsPerTimePeriod: {
      all: [],
      platforms: [],
    },
    relatedTags: [],
    userData: [],
  },
};

function setDateRange(state: BoardAnalyticsState, action: FSAInterface<SetAnalyticsDateRange['payload']>) {
  return {
    ...state,
    filters: {
      ...state.filters,
      dateFrom: action.payload?.from,
      dateTo: action.payload?.to,
    },
  };
}

function setPlatforms(state: BoardAnalyticsState, action: FSAInterface<SetAnalyticsPlatforms['payload']>) {
  return {
    ...state,
    filters: {
      ...state.filters,
      platforms: [...(action.payload?.platforms ?? [])],
    },
  };
}

function setInterval(state: BoardAnalyticsState, action: FSAInterface<SetAnalyticsInterval['payload']>) {
  return {
    ...state,
    filters: {
      ...state.filters,
      interval: action?.payload?.interval,
    },
  };
}

function updateBoardAnalytics(state: BoardAnalyticsState, action: any) {
  return {
    ...state,
    data: {
      ...action.payload,
    },
  };
}

const functionMap: FunctionMap = {
  [SET_ANALYTICS_DATE_RANGE]: setDateRange,
  [SET_ANALYTICS_PLATFORMS]: setPlatforms,
  [SET_ANALYTICS_INTERVAL]: setInterval,
  [GET_BOARD_ANALYTICS_SUCCESS]: updateBoardAnalytics,
};

export default createReducer(functionMap, initialState);
